import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Box, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { CommandComplianceType, SessionQualityDetectionsFieldsFragment } from '../../../../../../../../../../../generated/core-api/graphql-react-query';
import DurationFormat from '../../../../../../../../../../../utils/formatDuration';
import { isProjectCommand } from '../../../../../../CommandPage/Hooks/useCommands';
import StyledBox from './styles';

export default function DetectionQualityItem(props: { detection: SessionQualityDetectionsFieldsFragment, sessionCreatedAt: number }) {
  const {
    sessionCreatedAt,
    detection,
  } = props;
  const durationFormat = new DurationFormat({ style: 'narrow', timestampFormat: 'millisecond' });
  const time = durationFormat.format(detection.date - sessionCreatedAt);
  const { t } = useTranslation('session');
  if (!detection.projectTrigger || !isProjectCommand(detection.projectTrigger)) {
    return null;
  }
  return (
    <StyledBox>
      <Box>
        {isProjectCommand(detection.projectTrigger) && detection.projectTrigger.compliance === CommandComplianceType.Recommended ? <InsertEmoticonIcon color="success" /> : <SentimentVeryDissatisfiedIcon color="error" />}
        <Typography variant="body1">
          <Trans
            t={t}
            i18nKey="details.quality.mention"
            components={{ 1: <strong /> }}
            values={{ time, command: detection.projectTrigger.command.text }}
          />
        </Typography>
      </Box>
      <Typography variant="body2">
        {detection.ASRText?.trim()}
      </Typography>
    </StyledBox>
  );
}
